import { render, staticRenderFns } from "./systemUserDetailList.vue?vue&type=template&id=ec8694d6&scoped=true"
import script from "./systemUserDetailList.vue?vue&type=script&lang=js"
export * from "./systemUserDetailList.vue?vue&type=script&lang=js"
import style0 from "./systemUserDetailList.vue?vue&type=style&index=0&id=ec8694d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8694d6",
  null
  
)

export default component.exports